import React, {useEffect, useState} from 'react';
import Loader from "../../components/Loader";
import {Button, Col, FormControl, FormGroup, Image, Radio, Row, Checkbox} from 'react-bootstrap';
import PenguinSlider from "../../components/PenguinSlider";
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';
import {useSelector} from "react-redux";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

import './style.css';
import {SubscriptionModal} from "../../components/SubscriptionModal";
import {hasWizardPerm} from "../../utils/subscriptionUtils";

const upload_thumbnail_style = {
	height: 47,
	borderRadius: 3,
}

const wizard_heading_style = {
	color: '#FF841F',
  	fontFamily: 'Montserrat',
  	fontSize: 16,
	fontWeight: 600,
	letterSpacing: 0,
}

const copyrighting_heading_style = {
	color: '#453E38',
  	fontFamily: 'Montserrat',
  	fontSize: 14,
	fontWeight: 500,
	letterSpacing: 0,	
}


const ImageBox = ({ inner_html, show_preview_loader, on_click, name, idx, image_src, container_style, image_style, overlay_style, title_style, disable_overlay }) => {
	try {
		const default_container_style = {
			marginRight: 10, 
			display: 'inline-block'
		}

		const default_image_style = {
			borderRadius:6 , 
			cursor: 'pointer', 
			height: 120
		}

		return (
			<div key={idx} className="wizard_slider_container" onClick={on_click} style={{ ...default_container_style, ...container_style }}>
				{inner_html?(
					<div
						style={{ ...default_image_style, ...image_style}} 
						dangerouslySetInnerHTML={{__html: inner_html}}
					/>
				):(
					<Image 
						style={{ ...default_image_style, ...image_style}} 
						key={'horizonal-scroll-tempates'+idx}  
						src={image_src} 
						alt={'Image Not Found :P :P '}
					/>
				)}	
                {!disable_overlay && (
                	<React.Fragment>
                	{
                		show_preview_loader?( <div className="wizard_slider_overlay wizard_slider_overlay_show" style={{...overlay_style, zIndex: 999}}>
		            		<h6 className="wizard_slider_title" style={title_style} >Swapping Style...</h6>
		            	</div>):( <div className="wizard_slider_overlay" style={{...overlay_style, zIndex: 999}}>
		            		<h6 className="wizard_slider_title" style={title_style} >{name}</h6>
		            	</div>)
	                }
                	</React.Fragment>
                )}
            </div>
		)
	} catch(err) {
		console.log('error in image box', err)
		return 'Image box failed'
	}
}

ImageBox.defaultProps = {
	image_style : {},
	container_style: {},
	title_style: {},
	disable_overlay: false
}

const CopyrightingForm = ({ selected_tag, selected_tags, set_selected_tags, update_pg_json, photos, fetch_images, user, set_show_loader,inmagine_login }) => {
	try {
		const [ text_labels, set_text_labels ] = useState([]);
		const [ tag_filters, set_tag_filters ] = useState([]);
		const [ image_labels, set_image_labels ] = useState([]);
		const [ upload_label, set_upload_label ] = useState(null);
		const [ text_timeout, set_text_timeout ] = useState(null);

		const update_text_labels = ({ idx, new_value }) => {
			var updated_labels = [ ...text_labels ];
			updated_labels[idx] = { ...updated_labels[idx], value: new_value };
			set_text_labels(updated_labels);
		}

		const update_tag_filters = ({ idx, new_value }) => {
			var updated_filters = [ ...tag_filters ];
			updated_filters[idx] = { ...updated_filters[idx], value: new_value };
			set_tag_filters(updated_filters);
			set_selected_tags([ selected_tag._id, new_value.value ])
		}

		const update_image_labels = ({ label_id, new_value, new_image_fit, new_remove_bg }) => {
			try {
				if(!new_value){
					return
				}
				var updated_labels = [ ...image_labels ];
				updated_labels = updated_labels.map( x => x._id == label_id ? ({ ...x, value: new_value, image_fit:new_image_fit, remove_bg: Boolean(new_remove_bg) }) : x )
				// updated_labels[idx] = { ...updated_labels[idx], value: new_value };
				set_image_labels(updated_labels);
			} catch(err) {
				console.log(err);
			}
		}

		const upload_photo = async ({ file, label_id }) => {
			try {
				set_show_loader(true);
				var data = new FormData()
		        data.append('folder_id', user.my_photos_folder)
        		data.append('file', file, label_id);

		        var url = global.config.server_path + 'folder/upload_multiple_files';
		        var resp = await fetch(url, {method: 'POST', 'credentials': 'include', body: data})
		        resp = await resp.json();
		        set_upload_label(label_id);
		        fetch_images();
		        set_show_loader(false);
		        // console.log('upload_response ---------<<<>>>>>> ', resp);
			} catch(err) {
				console.log('error in uploading photos --< >>>>> ', err);
			}
		}


		useEffect(() => {
			if (selected_tag && selected_tag.copyright_labels && selected_tag.copyright_labels.length) {
				set_text_labels(selected_tag.copyright_labels.filter(x => x.type == 'text').map(x => ({ ...x, value: '' })));
				set_image_labels(selected_tag.copyright_labels.filter(x => x.type == 'image').map(x => ({ ...x, value: '',image_fit:'contain', remove_bg: false })));
				set_tag_filters(selected_tag.tag_filters.map(x => ({ ...x, value: '' })));
			}

		}, [ selected_tag ])

		useEffect(() => {
			update_pg_json({ text_labels, image_labels })
		}, [ image_labels ])

		useEffect(() => {
			if (text_timeout) {
				clearTimeout(text_timeout);
				set_text_timeout(null);
			}
			
			set_text_timeout(setTimeout(() => {
				update_pg_json({ text_labels, image_labels })
			}, 300));
		}, [ text_labels ])

		useEffect(() => {
			if (upload_label) {
				update_image_labels({ label_id: upload_label, new_value: /*photos[0].low_path||*/photos[0].path, new_image_fit:'contain' })
				set_upload_label(null);
			} 
		}, [ photos ])


		return (
			<div style={{ backgroundColor: '#faf9f9', paddingBottom: 20, paddingRight: 20, paddingLeft: 20, paddingTop: 10, height: 'calc(100% - 39px)',overflowY:'scroll' }}>
				{selected_tag ? (
					<React.Fragment>
						<div>
							{tag_filters.map((tag_filter, idx) => (
								<React.Fragment>
								<Row>
						            <Col sm={12}>
										<h5 style={copyrighting_heading_style}>{tag_filter.name}</h5>
										<FormGroup style={{ marginBottom: 0 }}>
                                        	<Select 
                                        		value={tag_filter.value} 
                                        		onChange={e => update_tag_filters({ idx, new_value: e })}
                                        		options={tag_filter.eligible_tags.map(x=>({ value: x._id, label: x.name }))} 
                                        		components={makeAnimated()}  
                                        	/>
									        <br/>
						        		</FormGroup>
						            </Col>
								</Row>
								</React.Fragment>
							))}	
						</div>
						<div style={{ paddingBottom: 20 }}>
							{image_labels.map((label, idx) => (
								<Row style={{ marginBottom: 5 }}>
									<Col xs={12}>
			                    	    <h5 style={copyrighting_heading_style}>{label.name}</h5>
			                            <FormControl
			                            	style={{ display: 'none' }}
								          	id={label._id}
								          	name={label.name}
								          	type="file"
								          	onChange={e => upload_photo({ label_id: label._id, file: e.target.files[0] })} 
								        />
								        <PenguinSlider id={label._id + "_slider"} height={60} >					        		
							        		<ImageBox 
					                            	key={'image_box_' + idx}
					                            	on_click={() => {user?document.getElementById(label._id).click():inmagine_login()}}
					                            	idx={idx}
					                            	image_src={global.config.server_path + 'public/images/plus.jpg'}
					                            	image_style={{ height: 60, border: '1px solid orange' }}
					                            	container_style={{ marginRight: 5}}
					                            	overlay_style={{ paddingTop: 5 }}
					                            	disable_overlay={true}
					                        />
					                    	{photos.map((photo, idx) => (
					                            <ImageBox 
					                            	key={'image_box_' + idx}
					                            	on_click={() => update_image_labels({ label_id: label._id, new_value: (/*photo.low_path||*/photo.path), new_image_fit:'contain' })}
					                            	idx={idx}
					                            	image_src={global.config.static_file_server_path + (photo.low_path||photo.path)}
					                            	name="✔"
					                            	image_style={{ height: 60 }}
					                            	container_style={{ marginRight: 5 }}
					                            	overlay_style={{ paddingTop: 20, display: (/*photo.low_path||*/photo.path) == label.value ? 'block' : 'none' }}
					                            	title_style={{ fontSize: 20 }}
					                            />
					                        ))}		                    	
					                    </PenguinSlider>
			                    		<br />
			                    		{label.value && (<React.Fragment>
				                    		Image Fit
				                    		<FormGroup style={{fontSize: '14px'}}>
										      <Radio name={"radioGroup_cover"+label._id} checked={label.image_fit=='cover'} onClick={e => update_image_labels({ label_id: label._id, new_value: label.value, new_image_fit:'cover' })} inline>
										        Cover
										      </Radio>
										      <Radio name={"radioGroup_contain"+label._id} checked={label.image_fit=='contain'} onClick={e => update_image_labels({ label_id: label._id, new_value: label.value, new_image_fit:'contain' })} inline>
										        Contain
										      </Radio>
										    </FormGroup>
				                    		<FormGroup style={{fontSize: '14px'}}>
										      <Checkbox name={"checkbox_remove_bg"+label._id} checked={label.remove_bg} onClick={e => update_image_labels({ label_id: label._id, new_value: label.value, new_image_fit:label.image_fit, new_remove_bg: !Boolean(label.remove_bg) })} inline>
										        Remove Background
										      </Checkbox>
										    </FormGroup>
									    </React.Fragment>)}
									</Col>	
								</Row>
							))}
						</div>
						<div>
							<Row>
								<Col xs={12}>	
									<h5 style={copyrighting_heading_style}>Fill in copywriting</h5>
								</Col>
							</Row>
							{text_labels.map((label, idx) => (
								<Row>
						            <Col sm={12}>
										<FormGroup>
							                <FormControl 
							                	id={label._id}
												name={label.name}
												type="text" 
												value={label.value}
												placeholder={label.name}
												onChange={e => update_text_labels({ idx, new_value: e.target.value })} 
									        />
									        <br/>
						        		</FormGroup>
						            </Col>
								</Row>
							))}	
						</div>
					</React.Fragment>	
				) : (
					<h4 style={copyrighting_heading_style}> Please choose a format to begin</h4>
				)}
			</div>
		); 	
	} catch(err) {
		console.log(err);
		return '';
	}
}

const DesignPreview = ({ selected_tag, pg_json, procedural_generation, preview_design, show_loader, set_show_loader,colors,set_colors }) => {
	try {
		const [ preview_src, set_preview_src ] = useState('');
		const [ selected_size, set_selected_size ] = useState(null);
		const [ show_swap_options, set_show_swap_options ] = useState(false);
		const [ color_index, set_color_index ] = useState(false);
		const [width, set_width] = useState(window.innerWidth);


		const switch_color = index => {
			set_show_swap_options(true);
			set_color_index(index);
		}

		const update_design_preview = () => {
			if (preview_design) {
				proc_gen(active_process_id)
			}
		}

		const proc_gen = async (process_id) => {
			if(process_id != active_process_id){
				return
			}
			set_show_loader(true);
			let { height: design_height, width: design_width } = preview_design.design_file;
			let { clientHeight: container_height, clientWidth: container_width } = document.getElementById('design_preview');
			let base_width, base_height;

			var design_aspect = design_width/design_height
			var container_aspect = container_width/container_height
			if (container_aspect < design_aspect) {
				base_width = container_width;
			} else {
				base_height = container_height;
			}

			var data = await procedural_generation(preview_design, base_width, base_height)
			// if(!preview_design.custom_colors){
			// 	var clrs = data.dominant_colors;
			// 	var new_clrs = colors.slice()
			// 	if(clrs[0]){
			// 		new_clrs[0] = clrs[0]
			// 	}
			// 	if(clrs[1]){
			// 		new_clrs[1] = clrs[1]
			// 	}

			// 	if(process_id != active_process_id){
			// 		return
			// 	}

			// 	set_colors(new_clrs)
			// }

			if(process_id != active_process_id){
				return
			}


			if (data) {
				set_preview_src(data.inner_html)
			}
			set_show_loader(false);
		}


		useEffect(() => {
			if (!show_swap_options) {
				set_color_index(0);
			}
		}, [ show_swap_options ])

		
		useEffect(() => {
			update_design_preview();
		},[ pg_json, preview_design, width ])

		
		useEffect(() => {
			const resize_handler = () => set_width(window.innerWidth);
			window.addEventListener("resize", resize_handler);
			return () => window.removeEventListener("resize", resize_handler);
		}, []);


		return (
			<div id="design_container" style={{ backgroundColor: '#faf9f9', padding: 10, paddingRight: 20, paddingLeft: 20, height: 'calc(100% - 39px)', position: 'relative' }}>
				{/*<div>
									{selected_tag && (
										<React.Fragment>
											<div style={{ display: 'flex', flexFlow: 'row', position: 'absolute' }}>
												<div style={{ cursor: 'pointer', backgroundColor: '#cccccc', width: 20, height: 10, marginRight: 10, marginTop: 5, border: selected_size == 0 ? '1px solid black' : 'none' }} onClick={ () => set_selected_size(0) } />
												<div style={{ cursor: 'pointer', backgroundColor: '#cccccc', width: 10, height: 10, marginRight: 10, marginTop: 5, border: selected_size == 1 ? '1px solid black' : 'none' }} onClick={ () => set_selected_size(1) } />
												<div style={{ cursor: 'pointer', backgroundColor: '#cccccc', width: 10, height: 20, border: selected_size == 2 ? '1px solid black' : 'none' }} onClick={ () => set_selected_size(2) } />
											</div>
											{colors.map((color, index) => (
												<span style={{ cursor: 'pointer', float: 'right', color, marginLeft: 5, fontSize: 20 }} onClick={ () => switch_color(index) } className="fa fa-circle" />	
											))}
											<SwapForm
												show_swap_options={show_swap_options}
												set_show_swap_options={set_show_swap_options}
												colors={colors}
												show_color_picker={true}
												color_index={color_index}
												update_colors={set_colors}
												show_only_color_picker={true}
												box_style={{ width: 'fit-content', marginTop: 26 }}
											/>
										</React.Fragment>
									)}
								</div>*/}
				<div id="design_preview" style={{ width:'100%', height:'100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					{show_loader && (
						<Loader 
							show_loader={show_loader}
							style={{}}
						/>
					)}
					{selected_tag && preview_src && (
						<ImageBox 
							inner_html={preview_src}
							idx={0}
							image_style={{width:'100%',height:'100%',objectFit:'contain'}}
						/>
						// <Image style={{width:'100%',height:'100%',objectFit:'contain'}} src={preview_src}></Image>
					)}
				</div>
				{!selected_tag && !show_loader && (
					<h4 style={copyrighting_heading_style}> Please choose a format to preview</h4>
				)}

			</div>
		);
	} catch(err) {
		console.log('error in design preview ---> ', err);
		return ' Design preview crashed';
	}
}


const WizardForm = ({ tags, selected_tag, set_selected_tag, selected_tags, set_selected_tags, user, pg_json,set_pg_json,procedural_generation,preview_design, colors, set_colors,inmagine_login }) => {
	try {
		const [ photos, set_photos ] = useState([]);
		const [ show_loader, set_show_loader ] = useState(false);

		const update_pg_json = ({ text_labels, image_labels }) => {
			try {
				var images = [];
				var text = [];
				[ text_labels, image_labels ] = [ text_labels.filter( x => x.value ), image_labels.filter( x => x.value ) ];
				if (text_labels.length) {
					text = text_labels.map( x => ({ label_id: x._id, text: x.value }));
				}
				if (image_labels.length) {
					images = image_labels.map( x => ({ label_id: x._id, src: x.value, image_fit: x.image_fit, remove_bg: x.remove_bg }));
				}

				const procedural_generation_parameters = { text, images };
				if(!window._.isEqual(procedural_generation_parameters,pg_json)){
					set_pg_json(procedural_generation_parameters); 
				}
			} catch(err) {
				console.log('error in updating pg_json --->>> ', err)
			}
	  	}

	  	const fetch_images = async () => {
	  		try {
	  			const url =  global.config.server_path + 'folder/get';
			    var resp = await fetch(url, { method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({ id: user.my_photos_folder }) })
			    resp = await  resp.json();
			    var photos = resp.data[0].folder.resources.reverse();
			    set_photos(photos);
	  		} catch(err) {
	  			console.log('error in fetching images ----> ', err)
	  		}
	  	}

	  	useEffect(() => {
	  		if (user) {
	  			fetch_images();
	  		}
	  	}, [ user ])

		return (
			<React.Fragment>
				<Row style={{padding: 25}}>
					<Col xs={12}>
						<h4 style={wizard_heading_style}> Pick a format </h4>
		                <div >
		                    <PenguinSlider id="wizard_slider" height={120} >
		                    	{tags.map((tag, idx) => (
		                            <ImageBox 
		                            	key={'image_box_' + idx}
		                            	on_click={() => set_selected_tag(tag)}
		                            	idx={idx}
		                            	image_src={tag.display_image}
		                            	name={tag.name}
		                            	overlay_style={{ display: (selected_tag  && tag._id == selected_tag._id) ? 'block' : '' }}
		                            />
		                        ))}		                    	
		                    </PenguinSlider>
		                </div>
		            </Col>
	            </Row>

				<Row style={{ paddingLeft: 25, paddingBottom: 25, paddingRight: 25, oveflowY: 'auto', height: 'calc(100vh - 345px)' }}>
					<Col xs={5} style={{ height: '100%' }} >
						<h4 style={wizard_heading_style}> Input variables </h4>
						<CopyrightingForm 
							update_pg_json={update_pg_json}
							selected_tag={selected_tag}
							selected_tags={selected_tags}
							set_selected_tags={set_selected_tags}
							fetch_images={fetch_images}
							photos={photos}
							user={user}
							inmagine_login={inmagine_login}
							set_show_loader={set_show_loader}
						/>
		            </Col>
		            <Col xs={7} style={{ height: '100%' }} >
						<h4 style={wizard_heading_style}> Preview </h4>
						<DesignPreview 
							selected_tag={selected_tag}
							pg_json={pg_json}
							procedural_generation={procedural_generation}
							preview_design={preview_design}
							show_loader={show_loader}
							set_show_loader={set_show_loader}
							colors={colors}
							set_colors={set_colors}
						/>
		            </Col>
	            </Row>
			</React.Fragment>
		);
	} catch(err) {
		console.log('error in wizard form ---> ', err);
		return ''
	}
}


const SwapForm = ({ user, show_preview_loader, set_show_preview_loader,show_swap_options, set_show_swap_options, colors, show_color_picker, update_colors, color_index, box_style, select_color, set_show_color_picker, show_only_color_picker, preview_data, set_preview_data, pg_designs, set_pg_designs, clearChanges }) => {
	try {
		const [ font_lock, set_font_lock ] = useState(true);
		const [ color_lock, set_color_lock ] = useState(false);
		const [ swap_index, set_swap_index ] = useState(-1);

		const default_box_style = {
			position: 'absolute',
			margin: 20,
			right: 0,
			borderRadius: 6,
			width: show_color_picker ? 'fit-content' : 300,
			boxShadow: '0 5px 20px 0 rgba(0,0,0,0.1)',
			backgroundColor: 'white',
			zIndex: 1000
		}

		const heading_style = {
			borderBottom: 'solid 2px #faf9f9',
			padding: 15
		}

		const button_style = {
			marginBottom: 10,
			color : '#FF841F',
		    border: '1px solid #FF841F',
		    paddingTop: 9,
		    paddingBottom: 9,
		    boxShadow: 'none',
		    textShadow: 'none', 
		    backgroundImage: 'none',
		    backgroundColor: 'white',
		}

		const overlay_style = {
			position: 'fixed',
			top: 0,
			left: 0,
			width: '100vw',
			height: '100vh',
			zIndex: 500
		}


		const alter_colors = color => {
			try {
				var tmp = JSON.parse(JSON.stringify(colors));
				tmp[color_index] = color;
				update_colors(tmp);
			} catch(err) {

			}
		}

		const close_swap_form = () => {
			if (show_color_picker) {
				set_show_color_picker(false);
			} else {
				set_show_swap_options(false)
			}
		}

		const applyChanges = async (process_id) => {
			if(process_id != active_process_id){
				return;
			}


			if(!font_lock || !color_lock){
				var loader_status = [...show_preview_loader]
				for (var i = 0; i < preview_data.length; i++) {
					loader_status[i] = true
				}

				set_show_preview_loader([...loader_status]);
			}else{
				return;
			}

			var data = [...preview_data.map(o => ({...o}))].slice()


			var tempFunctionFont = async (i,data) => {
				let { height: design_height, width: design_width } = data[i].design_file;
				let base_width, base_height;
				if (design_width > design_height) {
					base_width = 280;
				} else {
					base_height = 280;
				}

				var output = await process_manager.push_request(design => {
					design.load(data[i].design_file)
					design.draw();
					return design.fontSwap(0)
					.then(async () => {
						if(!color_lock){
							await design.colorSwap(1,[colors[0],colors[1]])
						}
						
						await design.wait_to_load();
						design.set_redraw_all_objects('text')
						return Promise.resolve();
					})
				}, base_width, base_height)
					
				data[i].swap_design_file = output.design_file;
				data[i].swap_src = output.src;
				data[i].swap_inner_html = output.inner_html;

				if(process_id != active_process_id){
					return;
				}

				if(process_id != active_process_id){
					return;
				}

				set_preview_data(prev_preview_data => {
					var new_preview_data = [...prev_preview_data];
					new_preview_data[i] = data[i];
					return new_preview_data;
				})

				set_show_preview_loader(prev_show_preview_loader => {
					var new_show_preview_loader = [...prev_show_preview_loader]
					new_show_preview_loader[i] = false;
					return new_show_preview_loader;
				})

			}

			var tempFunctionColor = async (i,data) => {
				let { height: design_height, width: design_width } = data[i].design_file;
				let base_width, base_height;
				if (design_width > design_height) {
					base_width = 280;
				} else {
					base_height = 280;
				}
				var output = await process_manager.push_request(async design => {
					design.load(data[i].design_file)
					design.draw();
					await design.colorSwap(1,[colors[0],colors[1]])
					await design.wait_to_load();
					return Promise.resolve()
				}, base_width, base_height);



				data[i].swap_design_file = output.design_file;
				data[i].swap_src = output.src;
				data[i].swap_inner_html = output.inner_html;
				
				if(process_id != active_process_id){
					return;
				}
				
				
				if(process_id != active_process_id){
					return;
				}


				set_preview_data(prev_preview_data => {
					var new_preview_data = [...prev_preview_data];
					new_preview_data[i] = data[i];
					return new_preview_data;
				})

				set_show_preview_loader((prev_show_preview_loader) => {
					var new_show_preview_loader = [...prev_show_preview_loader]
					new_show_preview_loader[i] = false;
					return new_show_preview_loader;
				})
			}

			if(!font_lock){
				for (var i = 0; i < data.length; i++) {
					if(process_id != active_process_id){
						return;
					}

					tempFunctionFont(i,data)
				}
			}

			if(!color_lock && font_lock){
				var prom_array = [];
				for (var i = 0; i < data.length; i++) {
					if(process_id != active_process_id){
						return;
					}

					tempFunctionColor(i,data)
				}
			}
		}

		return (
			show_swap_options ? (
				<React.Fragment>
					{show_color_picker ? (
						<React.Fragment>
							<div onClick={() => show_only_color_picker ? set_show_swap_options(false) : set_show_color_picker(false)} style={overlay_style}/>
							<div style={{ ...default_box_style, ...box_style }}>
								<Colour_Picker user={user} presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={colors[color_index]} onChange={ e => alter_colors(e.hex) } />
								{/* <Row style={heading_style}> */}
								{/* 	<span style={wizard_heading_style}>Color Picker</span> <span onClick={() => set_show_swap_options(false)} style={{ color: 'grey', cursor: 'pointer' }} className="fa fa-times pull-right"/> */}
								{/* </Row> */}
								{/* <Row style={{ margin: 15, textAlign: 'center' }}> */}
								{/* 	<Button className="btn-orange btn-sm" >Apply</Button> */}
								{/* </Row> */}
							</div>
						</React.Fragment>
					) : (
						<React.Fragment>
							<div onClick={() => set_show_swap_options(false)} style={overlay_style}/>
							<div style={{ ...default_box_style, ...box_style }}>
								<Row style={heading_style}>
									<span style={wizard_heading_style}>Style Swap</span> <span onClick={() => set_show_swap_options(false)} style={{ color: 'grey', cursor: 'pointer' }} className="fa fa-times pull-right"/>
								</Row>
								<Row style={{ margin: 15, textAlign: 'center' }}>
									{/* {<Button style={button_style} className="btn-block" onClick={() => set_font_lock(!font_lock)}>
										<span className="pull-left">Font</span>
										<span className={ font_lock ? "fa fa-lock pull-right" : "fa fa-lock-open pull-right" } />
									</Button>} */}
									<Button style={button_style} className="btn-block" >
										<span className="pull-left">Color</span>
										{colors.map((color, index) => (
											<span style={{ float: 'center', color, marginLeft: 5, fontSize: 16 }} className="fa fa-circle" onClick={ () => select_color(index) }/>	
										))}
										<span className={ color_lock ? "fa fa-lock pull-right" : "fa fa-lock-open pull-right" } onClick={() => set_color_lock(!color_lock)} />
									</Button>
									<Button onClick={clearChanges} style={{marginRight:'5px'}} className="btn-orange btn-sm" >Clear</Button>
									<Button onClick={() => applyChanges(active_process_id)} className="btn-orange btn-sm" >Apply</Button>
								</Row>
							</div>
						</React.Fragment>
					)}
				</React.Fragment>
			) : (
				''
			)
		)

	} catch(err) {
		console.log('error in swap form ===>>>> ', err);
		return '';
	}
}

SwapForm.defaultProps = {
	colors: [ '#F5F5DC', '#8A5B2F' ],
	show_color_picker: false,
	box_style: {},
	show_only_color_picker: false
}


const DesignsList = ({ user, selected_tag, show_form, set_show_form , preview_data, set_preview_data,pg_designs,set_pg_designs, show_loader, fetch_more_data,colors,set_colors}) => {
	try {
		const [page_no, set_page_no] = useState(0);
		const [ show_swap_options, set_show_swap_options ] = useState(false);
		const [ color_index, set_color_index ] = useState(0);
		const [ show_color_picker, set_show_color_picker ] = useState(false);
		const [ show_preview_loader, set_show_preview_loader ] = useState([]);

		const design_thumbnail_style = {
			width:300,
			height: 300,
			objectFit: 'contain'
		};

		const preview_data_onclick = (design_file,src,idx) => {
			if(!show_preview_loader[idx]){
				fetch(global.config.server_path+'saved_design/create_from_json/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({design_file: design_file})})
		        .then(resp => resp.json()).then(resp => resp.data)
		        .then(data => {
		        	var thumbnail_set = {
						id: data._id,
						thumbnail_data: src
					}
					return fetch(global.config.server_path + 'saved_design/update_thumbnail', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify(thumbnail_set)})
				    .then(function(r) {
		            	window.open(global.config.website_url + 'designmaker/start/designs/' + data._id +'/edit', '_blank');
				    })
		        })
		    }
		}

		const design_container_style = {
			margin: 10, 
			width: 300, 
			height: 300, 
			backgroundColor: '#faf9f9'
		}

		const option_button_style = {
			float: 'right',
			marginLeft: 5
		}

		const select_color = index => {
			set_color_index(index);
			set_show_color_picker(true);
		}

		const clearChanges = () => {
			if(preview_data && set_preview_data){
				active_process_id += 1;
				set_show_preview_loader(preview_data.map(o => true));
				var data = preview_data.slice()
				for (var i = 0; i < data.length; i++) {
					delete data[i].swap_design_file
					delete data[i].swap_src
					delete data[i].swap_inner_html
				}

				var new_set = pg_designs.slice();
				// delete new_set[0].custom_colors
				set_pg_designs(new_set)

				set_preview_data(data)
				set_show_preview_loader(preview_data.map(o => false))
			}
		}


		return (
			<Row style={{padding: 25}}>
				<Row>
					<span style={{ cursor: 'pointer', color: 'grey', fontWeight: 'bold' }} onClick={() => {clearChanges();set_show_form(true);}} className="fa fa-arrow-left" />
					<span style={{ ...wizard_heading_style, marginLeft:5 }}>Choose design to edit</span>
					<Button className="btn-orange" style={option_button_style} onClick={() => set_show_swap_options(true)}>Swap</Button>
					<SwapForm
						pg_designs={pg_designs}
						set_pg_designs={set_pg_designs}
						preview_data={preview_data}
						set_preview_data={set_preview_data}
						show_swap_options={show_swap_options}
						set_show_swap_options={set_show_swap_options}
						colors={colors}
						update_colors={set_colors}
						color_index={color_index}
						select_color={select_color}
						show_color_picker={show_color_picker}
						set_show_color_picker={set_show_color_picker}
						show_preview_loader={show_preview_loader}
						clearChanges={clearChanges}
						set_show_preview_loader={set_show_preview_loader}
						user={user}
					/>
				</Row>

				<br />
				{preview_data && preview_data.length>0 && (
					<React.Fragment>
						{preview_data.map((data, idx) => (
							<React.Fragment>
								<ImageBox 
									on_click={() => {preview_data_onclick(data.swap_design_file||data.design_file,data.swap_src||data.src,idx)}}
									inner_html={data.swap_inner_html||data.inner_html}
									name="Edit"
									idx={idx}
									image_style={{ height: 'auto', width: 'auto' }}
									// image_style={{ ...design_thumbnail_style }}
									container_style={{ ...design_container_style, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
									overlay_style={{ paddingTop: 90 }}
									show_preview_loader={show_preview_loader[idx]}
								/>
							</React.Fragment>
						))}	
					</React.Fragment>
				)}
				<Row>
					<Loader 
						show_loader={show_loader}
						style={{ width: '75%', height: 250, position: 'relative' }}
					/>
				</Row>

				<Row className="text-center">
		            {preview_data.length!=0 /*&& preview_data.length < pg_designs.length */&& (<Button className="btn btn-orange" onClick={() => {fetch_more_data(preview_data.length, 6)}} >Show more</Button>)}
	            </Row>
			</Row>
		);
	} catch(err) {
		console.log('error in designs listing ---> ', err);
		return 'Something went wrong while trying to preview the designs'
	}
}


const init_pg_designs = () => {
	for (var i = 0; i < process_manager.number_of_instances; i++) {
		process_manager.pg_designs[i] = new window.DM_Design();
		process_manager.pg_designs[i].base_width = 280;
		process_manager.pg_designs[i].handleWindowResize();
		process_manager.pg_designs[i].is_free = true;
		// process_manager.pg_designs[i].is_wizard = true;
	}
}

var active_process_id = 0;
var bgremoval_cache_map = {}

var process_manager = {
	number_of_instances: 6,
	pg_designs : [],
	active_process_id: 0,
	active_process_name: ''	,
	render_queue : [],
	clear_queue : () => {
		process_manager.render_queue = []
	},
	push_request: (fn, base_width, base_height) => {
		base_width = (!base_width && !base_height) ? 280 : base_width;
		var resolver, rejecter;

		var output_promise = new Promise(function(resolve, reject){
			resolver = resolve;
			rejecter = reject;
		});

		process_manager.render_queue.push({fn,resolver,rejecter, base_width, base_height});


		process_manager.execute();

		return output_promise;
	},
	execute: async () => {
		var free_design = process_manager.get_free_design();
		if(free_design && process_manager.render_queue.length>0){
			free_design.is_free = false;
			var current_item = process_manager.render_queue.shift();

			await current_item.fn(free_design);
			free_design.base_width = current_item.base_width;
			free_design.base_height = current_item.base_height;
			free_design.handleWindowResize();
			free_design.draw();

			current_item.resolver({
				src: free_design.pages[0].export('low'),
				inner_html: free_design.pages[0].get_html(),
        		design_file: free_design.save()
			});

			// free_design.clearMemory();
			free_design.is_free = true;
			process_manager.execute();
		}
	},
	get_free_design: () => {
		for (var i = 0; i < process_manager.pg_designs.length; i++) {
			if(process_manager.pg_designs[i].is_free){
				return process_manager.pg_designs[i];
			}
		}

		return null;
	}


}

window.A = process_manager;

const Wizard = () => {
	const user = useSelector(state => state.user);

	const [ all_tags, set_all_tags ] = useState([]);
	const [ tags, set_tags ] = useState([]);
	const [ pg_json, set_pg_json ] = useState({text:[],images:[]});
	const [ preview_data, set_preview_data ] = useState([]);
	const [ pg_designs, set_pg_designs ] = useState([]);
	const [ selected_tags, set_selected_tags ] = useState([]);
	const [ selected_tag, set_selected_tag ] = useState();
	const [ show_form, set_show_form ] = useState(true);
	const [ fetching_data, set_fetching_data ] = useState(false);
	const [ colors, set_colors ] = useState([ '#F8F8D8', '#9E2735' ]);
	const [displaySubscriptionModal, setDisplaySubscriptionModal] = useState(false);


	const inmagine_login = () => {
        window.localStorage.setItem('last_url', window.location.href);
        window.location.href = global.config.designs_ai_server_path + "user/sign-in?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
    };


	const fetch_tags = async () => {
		try {
			const url =  global.config.server_path + 'tag/get_all';
		    var resp = await fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
		    resp = await  resp.json()
		    var fetched_tags = resp.data.map( (x, idx) => ({ ...x, display_image: global.config.static_file_server_path + x.display_image}) );
		    set_all_tags(fetched_tags);
		    var sorted_tags = fetched_tags.filter(x => x.type == 'pg_category')
		    .sort((a,b) => b.priority - a.priority);
		    set_tags(sorted_tags);
		    if(sorted_tags && sorted_tags.length>0){
		    	set_selected_tag(sorted_tags[0]);
		    }
		} catch(err) {
			console.log(err);
		}
	}

	useEffect(() => {
		init_pg_designs()
		return () => {
			// console.log('unmounting design preview')
	  		// for (var i = 0; i < process_manager.pg_designs.length; i++) {
	  		// 	process_manager.pg_designs[i].destroy();
	  		// }
	  		process_manager.pg_designs = [];
		}
	},[]);



	const generate_preview_data = async (start, length,reset_data) => {
		if(pg_json){
			active_process_id += 1;
			var existing_designs = pg_designs.slice();
			if(reset_data){
				set_pg_designs([])
				set_preview_data([])
				existing_designs = [];
			}

			set_fetching_data(true);

			var resp = await fetch_pg_designs(start/length,length);
			var new_designs = resp.data.docs;
			var final_designs = existing_designs.concat(new_designs);
			set_pg_designs(final_designs);

			var design_count = final_designs.length;
			var slicing_index = (start + length > design_count ) ? Math.max(start + length - design_count, 0) : length; 
			var designs = final_designs.slice(start,start+length);
			if(reset_data){
				var data = []
			}else{
				var data = preview_data.slice()
			}

			var prom_array = [];
			for (var i = 0; i < designs.length; i++) {
				let { height: design_height, width: design_width } = designs[i].design_file;
				let base_width, base_height;
				if (design_width > design_height) {
					base_width = 280;
				} else {
					base_height = 280;
				}

				prom_array.push(procedural_generation(designs[i], base_width, base_height));
			}

			Promise.all(prom_array)
			.then(resultArray => {
				data = data.concat(resultArray);
				set_preview_data(data)
				set_fetching_data(false);
			})
		}
	}

	const procedural_generation = async (preview_design, base_width, base_height) => {
		try {
			var output = await process_manager.push_request(async design => {
				design.load(preview_design.design_file);
				design.draw();
	            await design.wait_to_load();
	            design.draw();
				for (var i = 0; i < pg_json.images.length; i++) {
					if(pg_json.images[i].src && pg_json.images[i].remove_bg && !bgremoval_cache_map[pg_json.images[i].src]){
						var image_raw = await window.loadStaticImage(pg_json.images[i].src);
						bgremoval_cache_map[pg_json.images[i].src] = await window.bg_removal_generic(image_raw,{
							enabled: true,
							feather: 0,
							offset: 0,
							sharpness: 0,
							crf: 0,
							matting: 0,
							cache:""
						})
					}
				}
				
                await design.proceduralGeneration(pg_json, false, bgremoval_cache_map);
			}, base_width, base_height)

			return {
        		src: output.src,
        		inner_html: output.inner_html,
        		design_file: output.design_file
        	}
				
		} catch(err) {
			console.log('error in procedural_generation ----> ', err);
		}
	}

	const fetch_pg_designs = async (page_no,size) => {
		active_process_id += 1;
		var resp = await fetch(global.config.server_path+'design/get_by_tag_id', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body: JSON.stringify({tag_id:selected_tags,page_no:page_no,size:size})})
		return resp.json();
	}

	const get_example_design = async () => {
		active_process_id += 1;
		if(selected_tag){
			// set_pg_designs([])
			// set_preview_data([])
			var resp = await fetch_pg_designs(0,1);
	    	set_pg_designs(resp.data.docs);
	    }
	}

	const update_colors = async (colors) => {
		// var new_set = JSON.parse(JSON.stringify(pg_designs))
		// new_set[0].custom_colors = colors
		// set_pg_designs(new_set)
		set_colors(colors);
	};

	const generate_designs_on_click =  () => {
		if (hasWizardPerm(user)) {
			set_preview_data([])
			set_show_form(false)
		} else {
			setDisplaySubscriptionModal(true);
		}
	};

	useEffect(() => {
		fetch_tags();
	}, [])

	useEffect(() => {
		if (selected_tag) {
			set_selected_tags([selected_tag._id]);
		}
	}, [selected_tag])

	useEffect(() => {
		get_example_design()
	}, [selected_tags])

	useEffect(() => {
		if(!show_form){
			generate_preview_data(0,6,true);
		}
	}, [show_form])


	return (
		<React.Fragment>
			<SubscriptionModal show={displaySubscriptionModal} hide={() => setDisplaySubscriptionModal(false)}/>
			<div style={{ marginLeft: '-40px' }}>
				<div style={{height: 'calc(100vh - 75px)', overflowY: 'scroll'}}>
					{show_form ? (
						<React.Fragment>
							<WizardForm
								pg_json={pg_json}
								set_pg_json={set_pg_json}
								tags={tags}
								selected_tag={selected_tag}
								selected_tags={selected_tags}
								set_selected_tag={set_selected_tag}
								set_selected_tags={set_selected_tags}
								user={user}
								procedural_generation={procedural_generation}
								preview_design={pg_designs[0]}
								colors={colors}
								set_colors={update_colors}
								inmagine_login={inmagine_login}
							/>
							<Row className="text-center">
								<Button className="btn btn-orange" disabled={!selected_tag || pg_designs.length===0} onClick={generate_designs_on_click} >Generate designs</Button>
							</Row>
						</React.Fragment>
					) : (
						<DesignsList
							selected_tag={selected_tag}
							preview_data={preview_data}
							set_preview_data={set_preview_data}
							set_show_form={set_show_form}
							fetch_more_data={generate_preview_data}
							show_loader={fetching_data}
							pg_designs={pg_designs}
							set_pg_designs={set_pg_designs}
							colors={colors}
							user={user}
							set_colors={set_colors}
						/>
					)}
				</div>
			</div>
		</React.Fragment>
	)
}


export default Wizard;
export {
	Loader
};